export default __webpack_public_path__ + "f72272937e6590340aa7a78dd49b0147.png";